export const SENTRY_PROJECT_NAME = "FASTSHIFT_PORTAL";
